<div class="flex flex-row gap-2 rounded bg-slate-600 pl-3 pr-4 py-2">
  <slot/>
</div>